import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  ViewChild,
  type OnInit,
} from '@angular/core';
import Splide from '@splidejs/splide';

@Component({
  selector: 'market-carousel-categories-skeleton',
  standalone: true,
  imports: [],
  templateUrl: './carousel-categories-skeleton.component.html',
  styleUrl: './carousel-categories-skeleton.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarouselCategoriesSkeletonComponent
  implements OnInit, AfterViewInit
{
  @ViewChild('splide') splide!: ElementRef<HTMLElement>;
  ngOnInit(): void {}
  ngAfterViewInit(): void {
    new Splide(this.splide.nativeElement, {
      type: 'loop',
      perPage: 3,
      arrows: false,
      pagination: false,
    }).mount();
  }
}
